import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, FormSection, SubmissionError, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import Modal from 'react-responsive-modal';

import FileField from '../FileInput'
import agent from '../../agent'


const validate = {
	photo: value => value ? undefined : 'Photo is required',
}

const renderError = ({ meta: { touched, error } }) => 
  touched && error ? <p className="form-error is-visible" id="uuid">{error}</p> : false 


class UploadImageForm extends Component {
	
	onSubmit = (values) => {
		let params = {
			artist: {
				avatar: values.photo,
				active_avatar: ""
			}
		}
		agent.Artist.updateDetails(this.props.artist.id, params.artist)
			.then(k => this.setState({showModal_info: true}))
		console.log('submit me', params, values)
	}
	onCloseModal = () => {
		this.setState({showModal_info: false})
	}

	render () {
		const { handleSubmit, previousPage, pristine, submitting, disableButton } = this.props
	  	const pFix = {
	  		color: '#008DEF',
	  		fontSize: '17px'
	  	}
	  	const pFix2 = {
	  		padding: '0 1rem'
	  	}
		return (
			<form onSubmit={handleSubmit} className="registartion-upload-image-form">
				<section className="section gray-bg">
					<div className="grid-x align-center">
						<div className="small-12 medium-10 large-8 cell text-center">
							<Field 
								className="artist-photo-dropzone"
								name="photo" 
								component={ FileField }  
								accept="image/jpeg,image/jpg,image/tiff,image/gif" 
								multiple={ false } 
								/>

							<Field name="photo" validate={[validate.photo]} component={renderError} />

							<div className="row">
								<div className="small-12 medium-centered text-center column">
									<div className="custom-checkbox">
						                <Field
						                  className="styled-checkbox"
						                  name="no_image"
						                  id="no-image"
						                  component="input"
						                  type="checkbox"
						                />
						                {
						                	// <label htmlFor="no-image">I can't now or don't have image. Please email me and will add later</label>
						                }
		              				</div>
								</div>
							</div>

							<div style={pFix2} className="row">
								<p style={pFix}>*Primary image should be in portrait format and be at<br/> least 1000 pixels in height and width and 150 DPI</p>
							</div>
						</div>
					</div>
				</section>

				<section className="section registration-action-buttons">
					<div className="grid-x align-center">
						<div className="small-12 cell text-center">
							<button className="button primary" 
	              type="submit" 
	              disabled={pristine || submitting || disableButton}>
	                {submitting || disableButton ? 'Saving...' : 'Save' }
	            </button>
							
						</div>
					</div>
				</section>
			</form>
		)
	}
}

UploadImageForm = reduxForm({
  form: 'artistProfile', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(UploadImageForm)

const mapStateToProps = state => ({
  
});

const mapDispatchToProps = dispatch => ({
  publicUpload: (id, avatar) =>
    dispatch({type: 'PUBLIC_UPLOAD', payload: agent.Artist.publicUpload(id, avatar) })
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadImageForm);


// WEBPACK FOOTER //
// ./src/components/profile/UploadImageForm.js